module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"forgot":{"cta":"Send new password","messages":{"success":"New password was succesfully sent to given e-mail"}}}}')
  delete Component.options._Ctor
}
